<template>
  <path
    d="M20 4.00024H4C2.9 4.00024 2.01 4.90024 2.01 6.00024L2 18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00024C22 4.90024 21.1 4.00024 20 4.00024ZM19.6 8.25024L12.53 12.6702C12.21 12.8702 11.79 12.8702 11.47 12.6702L4.4 8.25024C4.15 8.09024 4 7.82024 4 7.53024C4 6.86024 4.73 6.46024 5.3 6.81024L12 11.0002L18.7 6.81024C19.27 6.46024 20 6.86024 20 7.53024C20 7.82024 19.85 8.09024 19.6 8.25024Z"
  />
</template>
